import React from "react";
import PropTypes from "prop-types";

const Search = ({ className, color }) => {
  switch (color) {
    case `bone`:
      color = `#f4eee3`;
      break;

    case `grey`:
      color = `#969696`;
      break;

    case `clay`:
      color = `#CEB29A`;
      break;

    case `shampoo`:
      color = `#f9ae8f`;
      break;

    case `brown`:
      color = `#600E1B`;
      break;

    case `bronze`:
      color = `#E4AD8A`;
      break;

    case `scarlet`:
      color = `#6b0b1c`;
      break;

    case `cream`:
      color = `#e9b691`;
      break;

    case `orange`:
      color = `#e84829`;
      break;

    default:
      break;
  }

  //

  return (
    <svg className={className} viewBox="0 0 15.88 16.52">
      <g id="Layer_5" data-name="Layer 5">
        <path
          fill="none"
          stroke={color}
          d="M6.58,11.86A5.69,5.69,0,1,0,.51,6.58,5.69,5.69,0,0,0,6.58,11.86Z"
        />
        <line
          fill="none"
          stroke={color}
          x1="10.18"
          y1="10.48"
          x2="15.52"
          y2="16.18"
        />
      </g>
    </svg>
  );
};

Search.defaultProps = {
  className: ``,
  color: `#231f20`
};

Search.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string
};

export default Search;
